import React from 'react';
import LockIcon from '@mui/icons-material/Lock';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import Face6Icon from '@mui/icons-material/Face6';
import { useTranslation } from '../../i18n';

interface TrustBadgesProps {
    className?: string;
}

const TrustBadges: React.FC<TrustBadgesProps> = ({ className = '' }) => {
    const { t } = useTranslation();
    
    const badges = [
        {
            icon: <LockIcon sx={{ fontSize: '1.5rem' }} />,
            title: t('landing.trust_ssl_secured'),
            description: t('landing.trust_ssl_description')
        },
        {
            icon: <VerifiedUserIcon sx={{ fontSize: '1.5rem' }} />,
            title: t('landing.trust_privacy_protected'),
            description: t('landing.trust_privacy_description')
        },
        {
            icon: <Face6Icon sx={{ fontSize: '1.5rem' }} />,
            title: t('landing.trust_18_plus'),
            description: t('landing.trust_18_plus_description')
        }
    ];

    return (
        <div className={`trust-badges d-flex justify-content-center gap-3 ${className}`}>
            {badges.map((badge, index) => (
                <div 
                    key={index} 
                    className="trust-badge text-center"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title={badge.description}
                >
                    <div className="badge-icon text-muted mb-1">
                        {badge.icon}
                    </div>
                    <div className="badge-title small text-muted">
                        {badge.title}
                    </div>
                </div>
            ))}
        </div>
    );
};

export default TrustBadges;